import { createStyles } from '@mui/styles';
import { APTheme } from '../../../core/TenantProvider/tenants';

export default (theme: APTheme) => createStyles({
    "@keyframes onloadup": {
        "0%": {
            opacity: 0,
            transform: "translateY(65px)"
        },
        "100%": {
            opacity: 1,
            transform: "translateY(0)"
        }
    },
    BecomePartnerContainer: {
        maxWidth: 760,
        margin: '9em auto 4em',
        padding: '0 1.5em',
        animationName: `$onloadup`,
        animationDuration: '0.3s',
        animationFillMode: 'both',
        animationTimingFunction: 'cubic-bezier(0.680, -0.550, 0.265, 1.550) both',
        '@media(max-width: 768px)': {
            margin: '6em auto 4em',
        },
        '@media(max-width: 480px)': {
            margin: '4em auto 4em',
        },
        '& .stepContainer': {
            /* , */
        },
        '& .stepForm': {
        },
        '& .stepTracker': {
            marginTop: 0,
            minWidth: 200
        },
        '& .stepSectionAccordion': {
            padding: 0,
            backgroundColor: 'transparent',
            border: 'none',
            boxShadow: 'none',
            '& .MuiFormControlLabel-root': {
                display: 'block',
                width: 'auto',
                margin: '0 auto 30px',
                padding: 0,
                textAlign: 'center',
                '& .MuiTypography-body1': {
                    verticalAlign: 'middle'
                }
            },
            '& .stepAccordionGroup': {
                backgroundColor: '#fff',
                boxShadow: '0 0 4px 0 rgba(0,0,0,0.08)',
            },
            '& .MuiAccordion-root': {
                '&:first-child:before': {
                    display: 'none'
                },

                '&.Mui-expanded': {
                    margin: 0,
                },
                '&:before': {
                    opacity: 1,
                    display: 'block'
                },
                '& .MuiAccordionSummary-expandIcon': {
                    padding: 0,
                    marginRight: 0,
                    transform: 'rotate(180deg)',

                    '&.Mui-expanded': {
                        transform: 'rotate(0deg)'
                    }
                }
            },
            '& .MuiPaper-elevation1': {
                boxShadow: 'none'
            },

            '& .MuiAccordionSummary-root': {
                padding: '25px 30px',
                minHeight: 0,
                '@media(max-width: 480px)': {
                    padding: '20px 20px',
                },
            },

            '& .MuiAccordionSummary-content': {
                margin: 0,

                '& > p': {
                    color: '#4a4a4a',
                    fontWeight: '500',
                    letterSpacing: '-0.5px',
                    lineHeight: '18px',
                    margin: 0,
                },
            },
            '& .MuiCollapse-wrapperInner': {
                width: '100%',
                display: 'block',
                padding: '0 30px 30px 30px',
                background: '#fff',
                '@media(max-width: 480px)': {
                    padding: '0 20px 20px 20px',
                },
            },
            '& .MuiAccordionDetails-root': {
                display: 'block',
                padding: '30px',
                background: '#f5f5f5',
                '@media(max-width: 480px)': {
                    padding: '20px',
                },
                '& > div': {
                    width: '100%',
                    '& > span': {
                        marginBottom: 3,
                        '& + span': {
                            marginRight: 0,
                            marginBottom: 0,
                        },
                    },
                },
            }
        },
        '& .stepAccordion': {
        },
        '& .serverErrorMessage': {
            maxWidth: "100%"
        }
    },
    BecomePartnerFormContainer: {
    },
    BecomePartnerContainerTitle: {
        maxWidth: 537,
        color: '#4a4a4a',
        marginBottom: 40,
        '@media(max-width: 768px)': {
            textAlign: 'center',
            margin: '0 auto 40px'
        },
        '& > h1': {
            fontSize: 26,
            lineHeight: '34px',
            letterSpacing: '-0.5px',
            margin: '0 0 10px 0',
            fontWeight: 600,
            [theme.breakpoints.down('sm')]: {
                fontSize: '2.0rem',
            },
        },
        '& > p': {
            fontSize: 16,
            lineHeight: '24px',
            letterSpacing: '0',
            margin: 0,
            [theme.breakpoints.down('sm')]: {
                fontSize: '1.4rem',
                lineHeight: 1.45
            },
        }
    },
    BecomePartnerFormSteps: {
        '& > div': {
            margin: 0
        },
        '& .MuiFormControlLabel-root': {
            width: '100%',
            margin: 0,
            padding: 0,
            '&:last-of-type': {
                marginBottom: 30
            }
        },
        '& .radioGroup': {
            display: 'block',
            '& .MuiFormControlLabel-root': {
                marginBottom: 0,
                width: 'auto',
                '&:last-of-type': {
                    marginBottom: 0
                }
            }
        }
    },

});